export class Forbidden extends Error {
    public constructor(error: string) {
        super(error);
    }
}
